import React, {Suspense, useEffect} from 'react';
import {PaperProvider} from 'react-native-paper';
// Use the prebuilt version of RNVI located in the dist folder
import {I18nextProvider} from 'react-i18next';
import {QueryClient, QueryClientProvider} from 'react-query';
import {I18nManager} from 'react-native';
import {Provider} from 'react-redux';
import i18n from 'src/i18n/I18n';
import {ApiProvider} from 'src/providers/ApiProvider';
import SignalR from './components/signal-r/SignalR';
import {persistor, store} from 'src/store';
import {PersistGate} from 'redux-persist/integration/react';
import UIWrapper from 'src/pages/ui-wrapper/UIWrapper.component';
import Routes from 'src/components/routes/Routes.componet';
import {Router} from 'src/imports/Router';
import {AlertProvider} from 'src/providers/AlertProvider';
import RootAlert from 'src/components/root-alert/RootAlert';
import RootModal from 'src/components/root-modal/RootModal.component';
import ServiceWorkerWrapper from '../web/src/ServiceWorkerWrapper';
import RootSheet from './components/root-sheet/RootSheet.component';
import {getApp} from './actions/app';
import {isWeb} from './constants';
import {paperTheme} from './theme';
import Sentry from './imports/sentry';
import {BrowserTracing} from '@sentry/tracing';
import {autoUpdateApp} from 'src/utils/UpdateManager';
I18nManager.forceRTL(false);
I18nManager.allowRTL(false);

const App = () => {
  const queryClient = new QueryClient();

  useEffect(() => {
    autoUpdateApp();
    if (isWeb) {
      Sentry.init({
        dsn: 'https://72bb859a2be0520290c8a83a4f92f2ad@sentry.hamravesh.com/7502',
        integrations: [new BrowserTracing()],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
      
         sampleRate: 1.0,        // ← خطاها 100٪ ثبت شوند
         tracesSampleRate: 1.0,  // ← performance monitoring 100٪ فعال
        attachStacktrace: true,
        beforeSend: event => {
          const tags = event?.tags ?? [];
          const isException = !('api_error' in tags);
          const values = event?.exception?.values ?? [];
          const notHandled = values.some(
            item =>
              item?.mechanism?.handled == undefined ||
              item?.mechanism?.handled == false,
          );
          if (notHandled || !isException) {
            if (event.exception) {
              event.extra = {
                ...event.extra,
                customData: store.getState().user?.mobile,
              };
            }
            return event;
          } else {
            return null;
          }
        },
      });
    }
  }, []);

  if (isWeb) {
    window.addEventListener('orientationchange', function () {
      if (window.orientation !== 0) {
        store.dispatch(
          getApp({
            landscapeView: true,
          }),
        );
      } else {
        store.dispatch(
          getApp({
            landscapeView: false,
          }),
        );
      }
    });
  }

  return (
    <Provider store={store}>
      <Suspense fallback={<></>}>
        <I18nextProvider i18n={i18n} defaultNS={'translation'}>
          <PaperProvider theme={paperTheme}>
            <QueryClientProvider client={queryClient}>
              <Router>
                <ApiProvider>
                  <PersistGate
                    persistor={persistor}
                    onBeforeLift={() =>
                      new Promise(resolve => setTimeout(resolve, 3000))
                    }>
                    <AlertProvider>
                      <ServiceWorkerWrapper />
                      <UIWrapper>
                        <Routes />
                      </UIWrapper>
                    </AlertProvider>
                    <RootSheet />
                    <RootModal />
                    <RootAlert />
                    <SignalR />
                  </PersistGate>
                </ApiProvider>
              </Router>
            </QueryClientProvider>
          </PaperProvider>
        </I18nextProvider>
      </Suspense>
    </Provider>
  );
};

export default App;

// appcenter codepush release-react -a developzeero-gmail.com/zeero -d Production -t 1.13.0 --mandatory
